/* bios-load-mixer.js — Load choreography + audio mixer (extracted from main-content.liquid)
   - Listens for bios:boot-end and bios:portal-dismissed (whichever fires first)
   - Reveals zones in glitchy stages with floating instructional captions
   - Wires the top-right mixer to the YouTube background players
   Extracted to stay within Shopify's 256 KB section template limit. */
(function biosLoadChoreographyAndMixer() {
  'use strict';

  var ran = false;
  var isMobile = window.matchMedia('(max-width: 768px)').matches;

  /* ── Zone selectors — defensive lookups, may be null on some breakpoints ── */
  function $(sel) { return document.querySelector(sel); }
  function clearPreReveal() {
    var sels = ['.bios-header', '.bios-footer', '#bios-drum', '#bios-netfield',
                '#bios-chat', '#bios-telemetry'];
    sels.forEach(function (s) {
      var el = $(s);
      if (el) el.classList.remove('is-pre-reveal');
    });
  }

  /* Per-segment instruction-over-zone choreography.
     Each segment runs sequentially:
       t=0      instruction glitches in (center of zone)
       t=2000   zone glitch-reveals beneath/around instruction
       t=2700   instruction begins fading
       t=3700   instruction removed, next segment starts                       */
  var SEGMENTS = [
    {
      key: 'frame',  text: 'STATUS BAR + TERMINAL \u2014 site state \u00b7 type /help',
      reveal: function () { revealEls([$('.bios-header'), $('.bios-footer')]); }
    },
    {
      key: 'left',   text: 'BROWSE \u2014 scroll item names to navigate',
      reveal: function () { revealEls([$('#bios-drum')]); }
    },
    {
      key: 'right',  text: 'EXPLORE \u2014 scroll the node graph to traverse products',
      reveal: function () { revealEls([$('#bios-netfield')]); }
    },
  ];

  function revealEls(list) {
    list.forEach(function (el) {
      if (!el) return;
      el.classList.remove('is-pre-reveal');
      el.classList.add('is-revealing');
      setTimeout(function () { el.classList.remove('is-revealing'); }, 620);
    });
  }

  /* Pick the anchor element used to position the instruction over a segment.
     For the header & footer (very tall/short bands) we fall back to viewport
     center horizontally and the band's vertical center. */
  function anchorFor(segKey) {
    if (segKey === 'frame')  return null; /* center of viewport for header+footer */
    if (segKey === 'left')   return $('#bios-drum');
    if (segKey === 'right')  return $('#bios-netfield');
    if (segKey === 'market') return $('#bios-chat');
    return null;
  }

  function showInstruction(text, anchor) {
    var node = document.createElement('div');
    node.className = 'bios-instruction is-entering';
    var ruleL = document.createElement('span');
    ruleL.className = 'bios-instruction-rule';
    ruleL.textContent = '\u2500\u2500\u2500\u2500\u2500';
    var label = document.createElement('span');
    label.className = 'bios-instruction-text';
    label.textContent = text;
    var ruleR = document.createElement('span');
    ruleR.className = 'bios-instruction-rule';
    ruleR.textContent = '\u2500\u2500\u2500\u2500\u2500';
    node.appendChild(ruleL);
    node.appendChild(label);
    node.appendChild(ruleR);
    document.body.appendChild(node);

    function place() {
      if (!anchor) {
        node.style.left = '50%';
        node.style.top  = '50%';
        node.style.transform = 'translate(-50%, -50%)';
        return;
      }
      var r = anchor.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      node.style.left = cx + 'px';
      node.style.top  = cy + 'px';
      node.style.transform = 'translate(-50%, -50%)';
    }
    place();
    var onResize = function () { place(); };
    window.addEventListener('resize', onResize);

    return {
      el: node,
      startLeaving: function () {
        node.classList.remove('is-entering');
        node.classList.add('is-leaving');
      },
      destroy: function () {
        window.removeEventListener('resize', onResize);
        if (node.parentNode) node.parentNode.removeChild(node);
      }
    };
  }

  function runSegment(seg, done) {
    var anchor = anchorFor(seg.key);
    var instr  = showInstruction(seg.text, anchor);

    /* t=2000ms — zone glitch-reveals */
    setTimeout(function () { seg.reveal(); }, 2000);

    /* t=2700ms — start fading the instruction (zone is ~fully revealed) */
    setTimeout(function () { instr.startLeaving(); }, 2700);

    /* t=3700ms — remove instruction, hand off to next */
    setTimeout(function () { instr.destroy(); done(); }, 3700);
  }

  function runSequence(idx) {
    if (idx >= SEGMENTS.length) {
      /* All intro segments done — ensure any remaining is-pre-reveal elements
         (e.g. #bios-chat, #bios-telemetry) are fully revealed without a caption */
      clearPreReveal();
      return;
    }
    runSegment(SEGMENTS[idx], function () { runSequence(idx + 1); });
  }

  function runChoreography() {
    if (ran) return;
    ran = true;

    /* Tutorial choreography removed — reveal all zones immediately on every viewport.
       The portal exit transition (datamosh + logo fly, ~940ms) is enough handoff;
       the centered BROWSE/EXPLORE captions felt like a loading screen rather than
       part of the experience. Mobile already behaved this way. */
    clearPreReveal();
  }

  /* Boot-end is the primary trigger — runs after the boot screen is fully hidden */
  document.addEventListener('bios:boot-end', runChoreography);
  /* Portal-dismissed: only run immediately if there is no boot screen to wait for
     (direct skip / store path). If boot is still showing, wait for bios:boot-end.
     Always call clearPreReveal() when boot is already gone — this catches the case
     where the tutorial ran in the background while the portal was still up (boot-skip
     mode) and may not have finished before the user dismissed the portal. */
  document.addEventListener('bios:portal-dismissed', function () {
    var bootEl = document.getElementById('bios-boot');
    var bootGone = !bootEl || bootEl.style.display === 'none' || !bootEl.offsetParent;
    if (bootGone) {
      clearPreReveal();   /* always ensure zones are fully revealed now portal is gone */
      if (!ran) runChoreography();   /* run tutorial only if it hasn't started yet */
    }
  });
  /* Fallback: both events may have fired before this deferred script loaded */
  setTimeout(function () {
    var bootEl = document.getElementById('bios-boot');
    var bootGone = !bootEl || bootEl.style.display === 'none' || !bootEl.offsetParent;
    if (!ran && bootGone) runChoreography();
  }, 120);

  /* Audio mixer removed — player reverted to prior state. */
})();
